import React, { useEffect, useState } from "react";
import Header from "./../components/Header";
import Message from "./../components/LoadingError/Error";
import { useDispatch, useSelector } from "react-redux";
import {
  listProductDetails,
} from "../Redux/Actions/ProductActions";
import Loading from "../components/LoadingError/Loading";
import { PRODUCT_CREATE_REVIEW_RESET } from "../Redux/Constants/ProductConstants";

const SingleProduct = ({ history, match }) => {
  const [qty] = useState(1);
  
  const productId = match.params.id;
  const dispatch = useDispatch();
  
  const productDetails = useSelector((state) => state.productDetails);
  const { loading, error, product } = productDetails;
  const productReviewCreate = useSelector((state) => state.productReviewCreate);
  const {
    success: successCreateReview,
  } = productReviewCreate;
  
  // Check if user is logged in
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;
  
  useEffect(() => {
    if (successCreateReview) {
      alert("Review Submitted");
      dispatch({ type: PRODUCT_CREATE_REVIEW_RESET });
    }
    dispatch(listProductDetails(productId));
  }, [dispatch, productId, successCreateReview]);
  
  const AddToCartHandle = (e) => {
    e.preventDefault();
    history.push(`/cart/${productId}?qty=${qty}`);
  };
    
  // Updated handler for Request Similar button with localStorage caching for production reliability
  const requestSimilarHandler = () => {
    // First, ensure we cache the current product details in localStorage
    if (product) {
      const productToCache = {
        product: product._id,
        name: product.name,
        image: product.image,
        price: product.price
      };
      
      // Store in localStorage with a namespaced key
      localStorage.setItem(`customProduct_${productId}`, JSON.stringify(productToCache));
    }
    
    // Store custom order info in localStorage
    localStorage.setItem("isCustomOrder", "true");
    localStorage.setItem("customProductId", productId);
      
    // If user is not logged in, redirect to login first
    if (!userInfo) {
      // Save the return URL
      localStorage.setItem("customOrderRedirect", "shipping");
      history.push("/login");
    } else {
      // User is logged in, go directly to shipping
      history.push("/shipping?orderType=custom&productId=" + productId);
    }
  };
  
  return (
    <>
      <Header/>
      <div className="page-title-container">
        <div className="singlep-product-wrapper">
          {loading ? (
            <div className="singlep-loading-container">
              <Loading />
            </div>
          ) : error ? (
            <Message variant="alert-danger">{error}</Message>
          ) : (
            <div className="singlep-product-container">
              <div className="singlep-product-image-column">
                <div className="singlep-single-image">
                  <img src={product?.image} alt={product?.name} className="singlep-product-img" />
                </div>
              </div>
              <div className="singlep-product-details-column">
                <h2 className="singlep-product-name">{product?.name?.toUpperCase()}</h2>
                <h3 className="singlep-product-price">Ksh {product?.price}</h3>
                <div className="singlep-button-group">
                  <button onClick={AddToCartHandle} className="singlep-add-to-cart-btn">
                    ADD TO CART
                  </button>
                  <button onClick={requestSimilarHandler} className="singlep-add-to-cart-btn">
                    REQUEST SIMILAR
                  </button>
                </div>
                <div className="singlep-product-description">
                  <p>"{product?.description}"</p>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default SingleProduct;